import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isPaymentInput(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.PAYMENT_INPUT && typeof label === 'string' && Array.isArray(value);
}
function _formatPaymentInput(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatPaymentInput(submission) {
  if (isPaymentInput(submission)) {
    return _formatPaymentInput(submission);
  }
  return undefined;
}
//# sourceMappingURL=payment-input-preview.js.map